import React, { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';
import styles from './form.module.css';

const NumericInputForm = ({ content, onSubmit, isPreview = false, isLocked = false, userAnswer = null, allowUpdateResponse = true }) => {
    const min = content?.settings?.min !== undefined ? Number(content.settings.min) : undefined;
    const max = content?.settings?.max !== undefined ? Number(content.settings.max) : undefined;

    const [value, setValue] = useState(() => userAnswer?.value !== undefined ? String(userAnswer.value) : '');
    const [error, setError] = useState('');

    useEffect(() => {
        setValue(userAnswer?.value !== undefined ? String(userAnswer.value) : '');
        setError('');
    }, [userAnswer]);

    const hasSubmitted = userAnswer != null;
    const isDisabled = isLocked || (hasSubmitted && !allowUpdateResponse);
    const numVal = parseFloat(value);
    const isValid = value.trim() !== '' && !isNaN(numVal);
    const isUnchanged = hasSubmitted && isValid && numVal === userAnswer.value;
    const submitDisabled = isPreview || isLocked || !isValid || (hasSubmitted && (!allowUpdateResponse || isUnchanged));
    const submitLabel = !hasSubmitted ? (isLocked ? 'Voting Closed' : 'Submit') : (!allowUpdateResponse || isUnchanged ? 'Submitted ✓' : 'Update response');

    const validate = () => {
        if (!isValid) { setError('Please enter a valid number.'); return false; }
        if (min !== undefined && numVal < min) { setError(`Value must be at least ${min}.`); return false; }
        if (max !== undefined && numVal > max) { setError(`Value must be at most ${max}.`); return false; }
        setError('');
        return true;
    };

    const handleSubmit = () => {
        if (submitDisabled) return;
        if (!validate()) return;
        onSubmit({ value: numVal });
    };

    const placeholder = min !== undefined && max !== undefined
        ? `Enter a number (${min}–${max})`
        : min !== undefined ? `Enter a number (min: ${min})` : max !== undefined ? `Enter a number (max: ${max})` : 'Enter a number';

    return (
        <div className={styles.form}>
            <div className={styles.question}>
                {content.question || 'Enter a number'}
                {isLocked && <span className={styles.lockBadge}><Lock size={12} aria-hidden="true" /> Voting Locked</span>}
            </div>
            {content.settings?.description && content.settings?.descText && (
                <div className={styles.description}>{content.settings.descText}</div>
            )}
            <input
                type="number"
                className={styles.textInput}
                value={value}
                onChange={(e) => { if (!isDisabled) { setValue(e.target.value); setError(''); } }}
                placeholder={placeholder}
                min={min}
                max={max}
                disabled={isDisabled}
                onBlur={validate}
            />
            {error && <p className={styles.profanityError}>{error}</p>}
            <button className={styles.submitBtn} onClick={handleSubmit} disabled={submitDisabled}>
                {submitLabel}
            </button>
        </div>
    );
};

export default NumericInputForm;
